exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ra-input{display:inline-block;width:280px;height:40px;padding:10px 16px;font-size:12px;font-family:Microsoft YaHei,tahoma,arial,Hiragino Sans GB,\\\\5B8B\\4F53,sans-serif;line-height:20px;color:#55606e;border:2px solid #fff;border-radius:2px;background-color:#fff;box-sizing:border-box}.ra-input:focus{border:2px solid #24afb2;color:#24afb2;outline:none}.ra-input.success{border:2px solid #26ae90;color:#26ae90}.ra-input.error{border:2px solid #cd4237;color:#cd4237}.ra-input.disabled{border:2px solid #d2d4d8;color:#d2d4d8;cursor:not-allowed}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/less-loader!./~/react-as-input/src/index.less
 ** module id = 7
 ** module chunks = 0
 **/